import { linkTemplates } from '@atlassian/mpac-utils';
const prodEnv = {
  adminHubBaseUrl: 'https://admin.atlassian.com',
  mpacBaseUrl: 'https://marketplace.atlassian.com',
  mpacCdnBaseUrl: 'https://marketplace.atlassian.com',
  atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
  macBaseUrl: 'https://my.atlassian.com',
  wacBaseUrl: 'https://www.atlassian.com'
};
const stagingEnv = {
  adminHubBaseUrl: 'https://admin.stg.atlassian.com',
  mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  macBaseUrl: 'https://my.stg.internal.atlassian.com',
  wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
  atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com'
};
const developmentEnv = {
  adminHubBaseUrl: 'https://admin.stg.atlassian.com',
  mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  macBaseUrl: 'https://my.stg.internal.atlassian.com',
  wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
  atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com'
};
const localEnv = {
  adminHubBaseUrl: 'https://admin.stg.atlassian.com',
  mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  macBaseUrl: 'https://my.stg.internal.atlassian.com',
  wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
  atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com'
};
export const getBootstrapLinks = env => {
  switch (env) {
    case 'production':
      return linkTemplates(prodEnv);
    case 'staging':
      return linkTemplates(stagingEnv);
    case 'development':
      return linkTemplates(developmentEnv);
    case 'local':
      return linkTemplates(localEnv);
    default:
      {
        console.error('Marketplace App Tile: Unable to configure marketplace env:', +env);
        return linkTemplates(prodEnv);
      }
  }
};